import React, {useEffect, useState} from 'react'
import "../../style/common/_footer.scss";
import {Link} from "react-router-dom";
import ULMenuList from "../components/menu/ULMenuList";
import {url} from "../utils/urls";
import SearchBoxView from "../components/search/SearchBoxView";
import {isEmptyObject} from "../utils/objects";
import GoodsHistoryView from "../components/goodslist/GoodsHistoryView";
import {LazyLoadImage} from "react-lazy-load-image-component";
import {img} from "../utils/image";
import { isNotEmpty} from "../utils/strings";
import useAuth from "../auth/useAuth";

/**
 * フッタ
 * @returns {Element}
 * @constructor
 */
const Footer = (
  {footerElement = {},
    tel = "",
    hours = "",
    logo,
    copyright = {},
    shopMenus = [],
    isWhiteMode = false,
    isMiniFooter = false,
    footerSearch = {},
    footerHistory = {},
    footerImage = {},
  }) => {
  const [loading, setLoading] = useState(true);
  const { egifted } = useAuth();
  useEffect(() => {
    if (!loading) {
      return;
    }

    setTimeout(() => {
      setLoading(false);
    }, 200);
  }, [loading]);

  return (
    loading ?
      <></>
      :
    <>
    <div className="container-fluid footer-container">
      <div className={"row"}>
        {/*最近チェックした商品*/}
        {!isEmptyObject(footerHistory) && !egifted &&
          <div className="col-12">
            <GoodsHistoryView data={footerHistory}/>
          </div>
        }
      </div>
    </div>
    <div className="container-fluid footer-container">
      {!isMiniFooter &&
        <div className="row">
          {/*検索*/}
          {!isEmptyObject(footerSearch) && !egifted &&
            <div className="col-12">
              <SearchBoxView data={footerSearch} />
            </div>
          }
          {/*画像*/}
          {!isEmptyObject(footerImage) &&
            <div className="col-12 text-center">
              <LazyLoadImage src={img(footerImage?.["attr"]["src"])} className={"img-fluid mx-auto"}
                style={{...footerImage?.["style"]}}
              />
            </div>
          }
        </div>
        }

        {/*フッター*/}
        <footer id="gFooter" style={{
          ...footerElement["style"],
          // 背景画像
          backgroundImage: isNotEmpty(footerElement?.["attr"]?.["src"]) ? `url(${img(footerElement?.["attr"]?.["src"])})` : null,
          backgroundSize: "cover",
          backgroundPositionX: "center",
          backgroundPositionY: "center",
        }}>
          <div className="fBox flexB">
            {/*ロゴ*/}
            <div className="fLeft">
              <div className="fLogo">
                {!egifted &&
                  <Link to="/" className="hover"><img src={logo} alt=""/></Link>
                }
                {egifted &&
                  <img src={logo} alt="" />
                }

              </div>
            </div>
            {/*営業時間・電話番号*/}
            {isNotEmpty(tel) &&
            <div className="fRight">
              <p className="tel" style={{color: footerElement["style"]?.["color"]}}>
                <span className="roboto" >TEL:<a href="tel:" style={{color: footerElement["style"]?.["color"]}}>{tel}</a></span>（{hours}）
              </p>
            </div>
            }
          </div>
          {/*会社概要、問い合わせ、利用規約*/}
          <ULMenuList menus={shopMenus} ulClassName="fNavi flex"
                      idPrefix="f_"
                      fontColor={footerElement["style"]?.["color"]}
                      titleFontColor={footerElement["style"]?.["color"]} />
          {/*コピーライト*/}
          <address style={copyright["style"]}>
            {copyright["innerText"]}
          </address>
          <div className="pageTop">
            <a href="#headerTop"><img
              src={url(isWhiteMode ? "/img/common/black_page_top.png" : "/img/common/page_top.png")}
              alt="" className="img-fluid"/></a>
          </div>
        </footer>
      </div>
    </>
  )
};
export default Footer;